export default __webpack_public_path__ + "static/media/np-bg.c5deb305.webp";